import { render, staticRenderFns } from "./ViewerCanvas.vue?vue&type=template&id=16f1f9cf&"
import script from "./ViewerCanvas.vue?vue&type=script&lang=js&"
export * from "./ViewerCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ViewerCanvas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports